import { render, staticRenderFns } from "./merchant-application-error.vue?vue&type=template&id=9573da3a&lang=pug"
import script from "./merchant-application-error.vue?vue&type=script&lang=js"
export * from "./merchant-application-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports